import * as Yup from 'yup';

import { ApiKeysDTO } from '../service/apiKeys.interface';

export const initialValues: ApiKeysDTO = {
    api_key: '',
    client_id: '',
};
export const fields: Field[] = [
    {
        name: 'api_key',
        label: 'API ключ',
        type: 'text',
        position: 10,
    },
    {
        name: 'client_id',
        label: 'Client ID',
        type: 'text',
        position: 20,
    },
];

export const validationSchema = Yup.object({
    api_key: Yup.string().required('API ключ обязателен для заполнения'),
    client_id: Yup.string().max(255),
});

const FIELD_NAMES = Object.freeze(
    fields.reduce((acc, s) => {
        acc[s.name] = s.name;
        return acc;
    }, {} as Record<FieldNames, FieldNames>)
);

const visibleFieldsByType: Record<number, FieldNames[]> = {
    0: [],
    1: [FIELD_NAMES.api_key],
    2: [FIELD_NAMES.api_key, FIELD_NAMES.client_id],
};

export const getVisibleFields = (type: number): Field[] => {
    const keys = visibleFieldsByType[type];
    if (!keys) return [];
    return fields.filter(field => keys.includes(field.name));
};

export interface Field {
    name: string;
    label: string;
    type: string;
    position?: number;
}

export type FieldNames = (typeof fields)[number]['name'];
